// extracted by mini-css-extract-plugin
module.exports = {"Table":"Themes_Table__wGG3R"};